<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pi"></a><a class="page" id="pii"></a><a class="page" id="piii"></a>Looking for <b>The Stranger</b></h1>
<h1 class="bk1">Albert Camus and the Life of a Literary Classic</h1>
<p class="bkau">ALICE KAPLAN</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Kaplan-Stranger-US-pbk-0003.vue?de8f86aa